// eslint-disable-next-line import/extensions
import backgroundImage from '@/assets/images/loginRegisterImages/tlo.png';

// @vue/component
export default {
  name: 'LoginRegisterBackground',

  data() {
    return {
      backgroundImage,
    };
  },
};
